import { render, staticRenderFns } from "./ruoli.vue?vue&type=template&id=c12c5dae&"
import script from "./ruoli.vue.ts?vue&type=script&lang=ts&"
export * from "./ruoli.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports